import 'scss/solutions/screen-AR-solution.scss'
import 'babel-polyfill'
import 'js/libs/utils-solutions'

var video1 = document.getElementById('video1')
var video2 = document.getElementById('video2')
var video3 = document.getElementById('video3')
var videoList = {
  '0': video1,
  '1': video2,
  '2': video3
}

$(function () {
  $(document).on('mouseover', '.solutions-item-case li', function (e) {
    let $this = $(e.currentTarget)
    let index = $this.index()
    videoList[index].play()
  }).on('mouseout', '.solutions-item-case li', function (e) {
    let $this = $(e.currentTarget)
    let index = $this.index()
    videoList[index].pause()
  })
})



// WEBPACK FOOTER //
// ./src/js/entry/solutions/screen-AR-solution.js